// Pure SVG builder for the map location pin (no JSX/leaflet, runs under node --test).
const DEFAULT_SIZE_PX = 28;
// Only plain colour values may feed the --pin-glow custom property in the inline style.
const SAFE_COLOR = /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%/]+\)|[a-z]+)$/i;

function clampNumber(value, min, max) {
  if (!Number.isFinite(value)) return min;
  return Math.min(max, Math.max(min, value));
}

function escapeHtmlAttr(value) {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
}

/**
 * Returns `{ svg, size }` for a "location pin" marker.
 * - `fillColor` is taken directly from existing marker color logic (status/event colors)
 * - keeps a white stroke for contrast (matching the old circle marker outline)
 * - `variant: 'glass'` renders a translucent pin with a soft white outline
 */
export function pinIconSvg({
  fillColor,
  sizePx = DEFAULT_SIZE_PX,
  strokeColor = '#fff',
  strokeWidth = 0.5,
  variant = 'solid',
} = {}) {
  const size = clampNumber(sizePx, 14, 60);
  const strokeW = clampNumber(strokeWidth, 0, 6);
  const isGlass = variant === 'glass';
  const fill = fillColor || '#16A34A';
  const glow = SAFE_COLOR.test(fill) ? `--pin-glow:${fill};` : '';

  // A simple pin with a round "head". ViewBox is 24x24 so we can scale cleanly.
  const svg = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="${size}"
      height="${size}"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      style="display:block;${isGlass ? 'opacity:0.8;' : ''}${glow}"
    >
      <path
        d="M12 22s7-5.5 7-12a7 7 0 1 0-14 0c0 6.5 7 12 7 12Z"
        fill="${escapeHtmlAttr(fill)}"
        ${isGlass ? 'fill-opacity="0.75"' : ''}
        stroke="${escapeHtmlAttr(isGlass ? 'rgba(255,255,255,0.6)' : strokeColor)}"
        stroke-width="${strokeW}"
        stroke-linejoin="round"
      />
      <circle
        cx="12"
        cy="10"
        r="2.8"
        fill="${isGlass ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.9)'}"
      />
    </svg>
  `;

  return { svg, size };
}
